import type { Landmark } from '@erectus/shared';

/**
 * Rotate landmarks so the picture's vertical is true vertical.
 *
 * `rollDeg` is the angle from the picture's up to true up, positive toward
 * +x (lib/motion.ts `currentImageRoll`). Rotation happens in aspect-corrected
 * plane space about the picture centre, so lengths and angles are preserved;
 * visibility and z are untouched. A level phone (0°) returns the input.
 */
export function levelLandmarks(landmarks: readonly Landmark[], aspect: number, rollDeg: number): Landmark[] {
  if (rollDeg === 0) return landmarks as Landmark[];
  const a = (rollDeg * Math.PI) / 180;
  const cos = Math.cos(a);
  const sin = Math.sin(a);
  const cx = 0.5 * aspect;
  const cy = 0.5;
  return landmarks.map((lm) => {
    const x = lm.x * aspect - cx;
    const y = lm.y - cy;
    return { ...lm, x: (x * cos + y * sin + cx) / aspect, y: -x * sin + y * cos + cy };
  });
}
